var _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGenres = function SvgGenres(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 17"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 7.149,
    height: 7.149,
    x: 0.961,
    y: 0.719,
    fill: "#fff",
    rx: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 7.149,
    height: 7.149,
    x: 9.642,
    y: 0.719,
    fill: "#fff",
    rx: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 7.149,
    height: 7.149,
    x: 0.961,
    y: 9.57,
    fill: "#fff",
    rx: 1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 7.149,
    height: 7.149,
    x: 9.642,
    y: 9.57,
    fill: "#fff",
    rx: 1
  })));
};
export default SvgGenres;